import { Fragment } from "react"

export const Leftpart = ({children}) => {
    return (
        <Fragment>
           {children}
        </Fragment>
    )
}